<form [formGroup]="addressForm">
  <div class="row align-top gutters">
    <div class="col-md-12">
      <button
        mat-icon-button
        class="save-button"
        [disabled]="checkFormError() || !addressEditMode"
        [ngClass]="[
          !addressForm.pristine ? 'save-warn' : '',
          checkFormError() ? 'disabled' : ''
        ]"
        matTooltip="Save Changes"
        (click)="addressEditMode = false; saveAddress(addressForm.value)">
        <mat-icon>save</mat-icon>
      </button>
    </div>
  </div>

  <div class="row align-top gutters">
    <div class="col-md-12">
      @if (userService.mapsLoaded$ | async) {
        <app-address-autocomplete
          (onAddressChange)="VerifyAddress($event)"
          [form]="addressForm"
          formControlName="address"
          />
      }
    </div>
  </div>

  <div class="row align-top gutters">
    <div class="col-md-6">
      <mat-form-field>
        <mat-label>Address</mat-label>
        <input
          matInput
          type="text"
          name="address1"
          formControlName="address1"
          (keyup)="isVerified = false" />
      </mat-form-field>
      @if (isVerified) {
        <mat-icon class="icon-success">check_circle</mat-icon>
      }
      @if (!isVerified) {
        <mat-icon class="icon-warn">help</mat-icon>
      }
    </div>

    <div class="col-md-6">
      <mat-form-field>
        <mat-label>Address 2</mat-label>
        <input
          matInput
          type="text"
          name="address2"
          formControlName="address2" />
      </mat-form-field>
      <mat-icon></mat-icon>
    </div>
  </div>

  <div class="row align-top gutters">
    <div class="col-md-6">
      <mat-form-field>
        <mat-label>City</mat-label>
        <input
          matInput
          type="text"
          name="city"
          formControlName="city"
          (keyup)="isVerified = false" />
      </mat-form-field>
      @if (isVerified) {
        <mat-icon class="icon-success">check_circle</mat-icon>
      }
      @if (!isVerified) {
        <mat-icon class="icon-warn">help</mat-icon>
      }
    </div>

    <div class="col-md-6">
      <mat-form-field>
        <mat-label>State</mat-label>
        <input
          matInput
          type="text"
          name="state"
          formControlName="state"
          (keyup)="isVerified = false" />
      </mat-form-field>
      @if (isVerified) {
        <mat-icon class="icon-success">check_circle</mat-icon>
      }
      @if (!isVerified) {
        <mat-icon class="icon-warn">help</mat-icon>
      }
    </div>
  </div>

  @if (
    addressForm.get('city').hasError('required') ||
    addressForm.get('state').hasError('minlength') ||
    addressForm.get('state').hasError('maxlength') ||
    addressForm.get('state').hasError('pattern') ||
    addressForm.get('state').hasError('required')
    ) {
    <div
      class="row"
      >
      <div class="col-md-6">
        @if (addressForm.get('city').hasError('required')) {
          <small
            class="error-text"
            >
            City is required
          </small>
        }
      </div>
      <div class="col-md-6">
        @if (
          addressForm.get('state').hasError('minlength') ||
          addressForm.get('state').hasError('maxlength') ||
          addressForm.get('state').hasError('pattern')
          ) {
          <small
            class="error-text"
            >
            Needs to be a state abbreviation
          </small>
        }
        @if (addressForm.get('state').hasError('required')) {
          <small
            class="error-text"
            >
            State is required
          </small>
        }
      </div>
    </div>
  }

  <div class="row align-top gutters">
    <div class="col-md-6">
      <mat-form-field>
        <mat-label>Zip Code</mat-label>
        <input
          matInput
          type="text"
          name="zipcode"
          formControlName="zipcode"
          (keyup)="isVerified = false" />
        @if (addressForm.get('zipcode').hasError('pattern')) {
          <mat-error
            >Must be a valid zip code.</mat-error
            >
          }
        </mat-form-field>
        @if (isVerified) {
          <mat-icon class="icon-success">check_circle</mat-icon>
        }
        @if (!isVerified) {
          <mat-icon class="icon-warn">help</mat-icon>
        }
      </div>

      <div class="col-md-6">
        <mat-form-field>
          <mat-label>County</mat-label>
          <input
            matInput
            type="text"
            name="county"
            formControlName="county"
            (keyup)="isVerified = false" />
        </mat-form-field>
        @if (isVerified) {
          <mat-icon class="icon-success">check_circle</mat-icon>
        }
        @if (!isVerified) {
          <mat-icon class="icon-warn">help</mat-icon>
        }
      </div>
    </div>

    <div class="row align-top gutters">
      <div class="col-md-6">
        <mat-form-field>
          <mat-label>Latitude</mat-label>
          <input
            matInput
            type="text"
            name="lat"
            formControlName="lat"
            (keyup)="isVerified = false" />
          @if (addressForm.get('lat').hasError) {
            <mat-error
              >Must be valid coordinate.</mat-error
              >
            }
          </mat-form-field>
          @if (isVerified) {
            <mat-icon class="icon-success">check_circle</mat-icon>
          }
          @if (!isVerified) {
            <mat-icon class="icon-warn">help</mat-icon>
          }
        </div>

        <div class="col-md-6">
          <mat-form-field>
            <mat-label>Longitude</mat-label>
            <input
              matInput
              type="text"
              name="long"
              formControlName="long"
              (keyup)="isVerified = false" />
            @if (addressForm.get('long').hasError) {
              <mat-error
                >Must be valid coordinate.</mat-error
                >
              }
            </mat-form-field>
            @if (isVerified) {
              <mat-icon class="icon-success">check_circle</mat-icon>
            }
            @if (!isVerified) {
              <mat-icon class="icon-warn">help</mat-icon>
            }
          </div>
        </div>
      </form>
